import React from 'react'
import { Redirect } from 'react-router-dom'

const NerdifyPrime = () => {
    return <Redirect to="/orders" push={false} />
}

export default NerdifyPrime
